<template>
    <div class="f-topic" v-if="hasTopicData">
        <!-- 帖子标题头部 -->
        <topic-header @changeTopicLikeState="changeTopicLikeState"
            @toBoard="toBoard"
            @del="openConfirmToast"></topic-header>

        <!-- 帖子悬浮标题头部 -->
        <sticky-header @like="changeTopicLikeState"></sticky-header>

        <!-- 帖子内容 -->
        <div class="f-topic-content">
            <div class="f-topic-content-main">
                <!-- 帖子正文内容 -->
                <main-content
                    @changeTopicLikeState="changeTopicLikeState"
                    @click.native="checkExternalLink">
                </main-content>

                <!-- 官方处理流程板块（问答板块下仅技术支持、rd审核员、问题管理员、管理员可见） -->
                <official-process-board ref="officialBoard"
                    v-if="hasShowOfficialBoard">
                </official-process-board>
                <!-- 回复区域 -->
                <topic-reply id="topic-reply"
                    @click.native="checkExternalLink"
                    @openConfirmToast="openConfirmToast">
                </topic-reply>
            </div>
            <related-board></related-board>
        </div>

        <!-- 边栏置顶图标 -->
        <div v-if="isShowTop" class="f-topic-to-top" @click="scrollToId('app')">
            <span class="fa fa-angle-up fa-lg f-topic-to-top-icon"></span>
            <span class="f-topic-to-top-word">TOP</span>
        </div>
        <!-- 移动端点赞回复浮窗 -->
        <div v-if="!isShowTop" class="f-topic-to-top f-topic-like-reply">
            <like-btn
                :isLike="isEvaluated"
                class="f-topic-top-like-btn"
                @like="changeTopicLikeState">
            </like-btn>
            <span class="f-topic-top-reply-btn"
                @click="toggleReplyShow(true)">
                回复
            </span>
        </div>

        <!-- 普通确认弹窗 -->
        <ui-confirm-box :is-open="confirm"
            :title="confirmTitle"
            :tip="confirmTips"
            :btn-tip="confirmBtn"
            @operate="operate">
        </ui-confirm-box>

        <a
            class="customer-service"
            target="_blank"
            v-if="replyData.customerServiceUrl"
            :href="replyData.customerServiceUrl"
        >
            <div class="customer-service-icon"></div>
            <div class="customer-service-text">客服支持</div>
        </a>
    </div>
    <!--<div v-else>
        <img :src="errorImg" class="request-error">
    </div>-->
</template>

<style lang="less">
    @import '../../assets/less/views/topic-content/topic-content.less';
</style>

<script>
/* globals swan */
import MainContent from './components/MainContent.vue';
import RelatedBoard from './components/RelatedBoard.vue';
import OfficialProcessBoard from './components/official-process';
import TopicHeader from './components/TopicHeader.vue';
import TopicReply from './components/TopicReply.vue';
import StickyHeader from './components/StickyHeader.vue';
import LikeBtn from './components/LikeBtn.vue';
import ConfirmBox from '@/components/confirm-box/box';

import {debounce, throttle} from '@/utils/debounceThrottle';
import {scrollToId, getScrollTop, getWindowHeight, getOffsetTop} from '@/utils/decorate/scroll';
import {openNewWindow, addEvent} from '@/utils/decorate/event';
import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';
import toast from '@/utils/decorate/toast';
import isExternalLink from '@/utils/isExternalLink';

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => vm.prevRoute = from);
    },
    components: {
        'main-content': MainContent,
        'official-process-board': OfficialProcessBoard,
        'topic-header': TopicHeader,
        'topic-reply': TopicReply,
        'sticky-header': StickyHeader,
        'related-board': RelatedBoard,
        'like-btn': LikeBtn,
        'ui-confirm-box': ConfirmBox
    },
    data() {
        return {
            confirm: false,
            // errorImg: this.$store.state.home.errorImg,
            isShowTop: false,
            confirmTips: '',
            confirmTitle: '',
            confirmBtn: '',
            confirmType: '',
            replyId: '',
            prevRoute: null,
            externalLink: '',
        };
    },
    mounted() {
        if (this.isSwan) {
            this.swanWatch();
        }
        else {
            let topicId = this.$route.params.topicid;
            let pageNo = this.$route.query.pageNo ? this.$route.query.pageNo : 1;

            this.$store.dispatch('getWholeTopicContent', {id: topicId, pageNo})
                .then(() => {
                    if (this.prevRoute.name === 'userCenter') {
                        this.$store.dispatch('getMsgNum');
                    }
                })
                .catch(errmsg => {
                    if (typeof errmsg === 'string' && errmsg.indexOf('issue not topic') > -1) {
                        let issueid = +errmsg.slice(15);
                        this.$router.replace({name: 'issueContent', params: {issueid}});
                        return;
                    }
                    this.$router.replace('/');
                });

            this.$store.dispatch('getRelatedUrl', topicId);
        }

        this.mobileScroll();
    },
    destroyed() {
        this.destroy();
    },
    computed: {
        ...mapGetters([
            'hasStickyReply',
            'hasShowOfficialBoard'
        ]),
        ...mapState({
            topicData: state => state.topicContent.topicData,
            replyData: state => state.topicContent.replyData,
            isEvaluated: state => state.topicContent.topicData.isEvaluated,
            isPc: state => state.common.isPc,
            isSwan: state => state.common.isSwan,
            swanPages: state => state.common.swanPages,
            isReplyShow: state => state.topicContent.isReplyShow
        }),
        hasTopicData() {
            return Object.keys(this.topicData).length;
        }
    },
    methods: {
        ...mapMutations(['toggleReplyShow']),
        ...mapActions(['makeReplyAccepted', 'makeReplyRecommended']),
        scrollToId,
        watchHandler(to, from) {
            // 统计pv
            _hmt.push(['_trackPageview', '/forum' + to.path]);

            let params = Object.assign({}, to.params);
            let query = Object.assign({}, to.query);
            query.topicId = +params.topicid;
            this.$store.dispatch('getReplyContent', {query})
                .then(() => {
                    if (to.query.pageNo && to.query.pageNo !== from.query.pageNo) {
                        scrollToId('replyTop');
                    }
                });
        },

        /**
             * 移动端滚动决定置顶图标出现
             */
        mobileScroll() {
            addEvent(window, 'scroll', () => {
                const scrollTop = getScrollTop();
                const clientY = getWindowHeight();
                if (this.isPc) {
                    if (scrollTop > clientY) {
                        this.isShowTop = true;
                    }
                    else {
                        this.isShowTop = false;
                    }
                }
                else {
                    let replyTop = getOffsetTop('topic-reply');
                    if (replyTop && (scrollTop + clientY > replyTop + 200)) {
                        this.isShowTop = true;
                    }
                    else {
                        this.isShowTop = false;
                    }
                }
            });
        },

        /**
             * 小程序页面数据获取函数
             */
        swanWatch() {
            this.toggleReplyShow(false);
            this.confirm = false;
            let topicId = this.$route.topicid;
            let pageNo = this.$route.pageNo ? this.$route.pageNo : 1;
            this.listenScroll();

            this.$store.dispatch('getWholeTopicContent', {id: topicId, pageNo})
                .catch(errmsg => {
                    if (typeof errmsg === 'string' && errmsg.indexOf('issue not topic') > -1) {
                        let issueid = +errmsg.slice(15);
                        openNewWindow(`${this.swanPages.issueContent}?issueid=${issueid}`);
                        return;
                    }
                    openNewWindow(`${this.swanPages.home}?moduleid=0&tagId=0`);
                });
        },

        /**
             * 小程序滚动决定置顶图标出现
             * 覆盖了 swan-decorator 文件里的 onPageScroll 函数
             *
             * @param {Object} e 目标对象
             */
        listenScroll(e) {
            const clientY = getWindowHeight();
            let query = swan.createSelectorQuery();
            let that = this;
            query.select('#topic-reply').boundingClientRect(function (res) {
                if (res && (res.top < clientY - 200)) {
                    that.isShowTop = true;
                }
                else {
                    that.isShowTop = false;
                }
            }).exec();
        },
        toBoard() {
            let boardId = this.topicData.boardInfo.id;
            if (boardId < 3) {
                this.$router.push({name: 'homeTab', params: {moduleid: boardId}});
            }
            else {
                this.$router.push('/topic/list2/' + this.topicData.boardInfo.id);
            }
        },
        changeTopicLikeState: throttle(function () {
            if (this.$store.state.header.isLogin) {
                this.$store.dispatch('changeTopicLikeState');
            }
            else {
                this.$store.dispatch('navToPassport');
            }
        }),
        openConfirmToast({type, replyId, externalLink}) {
            this.confirm = true;
            this.confirmType = type;
            switch (type) {
                case 'login': this.confirmTips = '您还没有登录，确认要登录吗?';
                    break;
                case 'delReply': this.confirmTitle = '确认删除回复';
                    this.confirmTips = '回复删除后将不可恢复';
                    this.confirmBtn = '删除';
                    this.replyId = replyId;
                    break;
                case 'recommend': this.confirmTitle = '确认推荐此回复';
                    this.confirmTips = '每个帖子只能推荐一个优质回复，确认推荐后不可撤销';
                    this.confirmBtn = '推荐';
                    this.replyId = replyId;
                    break;
                case 'accept': this.confirmTitle = '确认采纳此回复';
                    this.confirmTips = '每个帖子只能采纳一个满意回复，确认采纳后不可撤销';
                    this.confirmBtn = '采纳';
                    this.replyId = replyId;
                    break;
                case 'delete': this.confirmTitle = '确认删除帖子';
                    this.confirmTips = '删除后帖子内容及回复将一并被删除，且不可恢复';
                    this.confirmBtn = '删除';
                    break;
                case 'promptExternalLink':
                    this.confirmTitle = '您即将访问第三方站点，请注意保护您的信息安全';
                    this.confirmTips = `即将去往：${externalLink}`;
                    this.confirmBtn = '确定';
                    this.externalLink = externalLink;
                    break;
            }
        },
        ok: debounce(function () {
            switch (this.confirmType) {
                case 'login': this.$store.dispatch('navToPassport');
                    break;
                case 'delReply': this.delReply();
                    break;
                case 'accept':
                    this.makeReplyAccepted(this.replyId)
                        .then(() => {
                            if (this.isSwan) {
                                let tmpList = Object.assign({}, this.topicData.ext.replyTopInfo.replyList);
                                this.$store.commit('changeTopAreaList', {});
                                this.$nextTick(() => {
                                    this.$store.commit('changeTopAreaList', tmpList);
                                });
                            }
                        })
                        .then(() => {
                            scrollToId('replyTopArea');
                        })
                        .catch(errmsg => toast.error(errmsg));
                    break;
                case 'recommend':
                    this.makeReplyRecommended(this.replyId)
                        .then(() => {
                            if (this.isSwan) {
                                let tmpList = Object.assign({}, this.topicData.ext.replyTopInfo.replyList);
                                this.$store.commit('changeTopAreaList', {});
                                this.$nextTick(() => {
                                    this.$store.commit('changeTopAreaList', tmpList);
                                });
                            }
                        })
                        .then(() => {
                            scrollToId('replyTopArea');
                        })
                        .catch(errmsg => toast.error(errmsg));
                    break;
                case 'delete': this.delTopic('delete');
                    break;
            }
        }),
        delTopic(type) {
            let topicId = this.topicData.topicInfo.topicId;
            let enable = 1;
            this.$store.dispatch('managerOperation', {type, topicId, enable})
                .then(() => {
                    this.toBoard();
                });
        },
        delReply() {
            let replyId = this.replyId;
            let topicId = this.topicData.topicInfo.topicId;
            this.$store.dispatch('managerOperation', {type: 'delReply', replyId})
                .then(() => {
                    let topicId = this.topicData.topicInfo.topicId;
                    this.$store.dispatch('getReplyContent', {query: {topicId}});
                })
                .then(() => {
                    this.$store.dispatch('getTopicContent', {id: topicId});
                    this.$store.commit('updateReplyDeleteState', {replyId, hasTopReply: this.hasStickyReply});
                });
        },
        changeConfirm(val) {
            this.confirm = val;
        },
        destroy() {
            this.$store.commit('clearTopicContentData');
        },
        operate(type) {
            if (type === 'ok') {
                // 单独处理，规避this.ok中debounce的延迟
                if (this.confirmType === 'promptExternalLink') {
                    window.open(this.externalLink, '_blank', 'noopener');
                }
                else {
                    this.ok();
                }
            }
            this.changeConfirm(false);
        },
        checkExternalLink(e) {
            // 处理点击链接的情况
            const curTarget = e.currentTarget;
            const linkEl = e.target.closest('a'); // 查找最近的链接
            // 处理内容或回复区域的链接
            if (linkEl && curTarget.contains(linkEl)) {
                // 没有hostname的不合法链接直接忽略点击
                if (!linkEl.hostname) {
                    e.preventDefault();
                }
                else if (isExternalLink(linkEl.hostname)) { // 非白名单链接弹窗提示用户确认
                    e.preventDefault();
                    this.openConfirmToast({type: 'promptExternalLink', externalLink: linkEl.href});
                }
            }
        },
    }
};
</script>
